import { propertyAvailabilityOptions, propertyFormFields, propertyTypeOptions } from '../../konstanter/adminConfig';
import { apiClient } from '../../tjenester/apiClient';

function AdminPropertyFormSection({
  editingSlug,
  handlePropertySubmit,
  imageUploadError,
  isUploadingImage,
  propertyForm,
  removePropertyImage,
  resetPropertyForm,
  setPropertyForm,
  uploadPropertyImage,
}) {
  return (
    <section className="rounded-[28px] border border-[#1832281a] bg-[rgba(249,245,238,0.9)] p-6 shadow-[0_22px_60px_rgba(24,50,40,0.08)]">
      <p className="mb-2 text-xs uppercase tracking-[0.14em] text-[#7c6b52]">Eiendomsskjema</p>
      <h2 className="font-serif text-2xl font-semibold text-[#163127]">
        {editingSlug ? 'Rediger eiendom' : 'Opprett ny eiendom'}
      </h2>
      <form className="mt-5 grid gap-4" onSubmit={handlePropertySubmit}>
        {propertyFormFields.map(([field, label]) => (
          <label className="grid gap-2" key={field}>
            <span className="text-sm font-semibold text-[#355046]">{label}</span>
            <input
              className="rounded-2xl border border-[#1832281f] bg-white px-4 py-3"
              onChange={(event) => setPropertyForm((current) => ({ ...current, [field]: event.target.value }))}
              type="text"
              value={propertyForm[field]}
            />
          </label>
        ))}
        <label className="grid gap-2">
          <span className="text-sm font-semibold text-[#355046]">Type</span>
          <select
            className="rounded-2xl border border-[#1832281f] bg-white px-4 py-3"
            onChange={(event) => setPropertyForm((current) => ({ ...current, type: event.target.value }))}
            value={propertyForm.type}
          >
            <option value="">Velg type</option>
            {propertyTypeOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
        <label className="grid gap-2">
          <span className="text-sm font-semibold text-[#355046]">Kategori</span>
          <select
            className="rounded-2xl border border-[#1832281f] bg-white px-4 py-3"
            onChange={(event) => setPropertyForm((current) => ({ ...current, availability: event.target.value }))}
            value={propertyForm.availability}
          >
            {propertyAvailabilityOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
        <div className="grid gap-2">
          <span className="text-sm font-semibold text-[#355046]">Bilder</span>
          {propertyForm.images && propertyForm.images.length > 0 ? (
            <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
              {propertyForm.images.map((image, index) => (
                <div className="relative" key={image}>
                  <img
                    alt={`Eiendomsbilde ${index + 1}`}
                    className="h-28 w-full rounded-2xl border border-[#1832281f] object-cover"
                    src={apiClient.resolveMediaUrl(image)}
                  />
                  {index === 0 ? (
                    <span className="absolute left-2 top-2 rounded-full bg-[rgba(29,76,59,0.92)] px-2 py-0.5 text-[0.7rem] font-semibold text-[#f9f5ee]">
                      Forsidebilde
                    </span>
                  ) : null}
                  <button
                    aria-label="Fjern bilde"
                    className="absolute right-2 top-2 flex h-7 w-7 items-center justify-center rounded-full border border-[#1832281f] bg-[rgba(255,255,255,0.9)] text-[#a23b3b]"
                    onClick={() => removePropertyImage(image)}
                    type="button"
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-sm text-[#7c6b52]">Ingen bilder lastet opp enna. Forste bilde blir forsidebilde.</p>
          )}
          <input
            accept="image/png,image/jpeg,image/webp,image/gif"
            className="rounded-2xl border border-[#1832281f] bg-white px-4 py-3 text-sm"
            disabled={isUploadingImage}
            multiple
            onChange={(event) => {
              const files = Array.from(event.target.files || []);
              files.forEach((file) => uploadPropertyImage(file));
              event.target.value = '';
            }}
            type="file"
          />
          {isUploadingImage ? <p className="text-sm text-[#355046]">Laster opp bilde ...</p> : null}
          {imageUploadError ? <p className="text-sm text-[#a23b3b]">{imageUploadError}</p> : null}
        </div>
        <label className="grid gap-2">
          <span className="text-sm font-semibold text-[#355046]">Fasiliteter (en per linje)</span>
          <textarea
            className="min-h-[120px] rounded-2xl border border-[#1832281f] bg-white px-4 py-3"
            onChange={(event) =>
              setPropertyForm((current) => ({
                ...current,
                facilities: event.target.value.split('\n').filter(Boolean),
              }))
            }
            value={(propertyForm.facilities || []).join('\n')}
          />
        </label>
        <label className="grid gap-2">
          <span className="text-sm font-semibold text-[#355046]">Kort beskrivelse</span>
          <textarea
            className="min-h-[120px] rounded-2xl border border-[#1832281f] bg-white px-4 py-3"
            onChange={(event) => setPropertyForm((current) => ({ ...current, summary: event.target.value }))}
            value={propertyForm.summary}
          />
        </label>
        <div className="flex flex-wrap gap-3">
          <button className="inline-flex min-h-12 items-center justify-center rounded-full bg-[#1d4c3b] px-6 font-semibold text-[#f9f5ee]" type="submit">
            Lagre eiendom
          </button>
          {editingSlug ? (
            <button
              className="inline-flex min-h-12 items-center justify-center rounded-full border border-[#1832281f] bg-white px-6 font-semibold text-[#355046]"
              onClick={resetPropertyForm}
              type="button"
            >
              Avbryt redigering
            </button>
          ) : null}
        </div>
      </form>
    </section>
  );
}

export default AdminPropertyFormSection;